import { FC } from 'react'

import { ISvgClass } from '../interface'

const FAQIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M290 4924 c-30 -8 -73 -26 -96 -39 -61 -36 -139 -126 -166 -193 l-23 -57 -3 -1369 c-2 -1210 0 -1376 13 -1430 29 -111 107 -205 214 -255 52 -24 67 -26 224 -29 l167 -3 0 -317 c0 -296 1 -318 20 -356 11 -23 32 -50 47 -60 35 -26 122 -33 160 -14 15 8 208 153 428 322 l400 309 6 -189 c6 -204 14 -243 66 -314 35 -47 75 -81 133 -111 l45 -24 849 -3 849 -2 361 -278 c438 -337 414 -320 464 -328 55 -9 123 24 154 74 22 36 23 47 26 284 l3 246 122 4 c105 3 129 6 172 27 66 33 131 100 163 169 l27 57 0 1125 0 1125 -22 48 c-31 66 -105 142 -172 174 l-56 28 -312 3 -312 3 -3 547 -3 547 -33 67 c-41 84 -128 167 -209 200 l-58 23 -1795 2 c-1557 2 -1802 0 -1850 -13z m3605 -329 l25 -24 0 -1329 c0 -1252 -1 -1331 -18 -1351 l-17 -21 -1080 -2 c-904 -3 -1084 -5 -1105 -17 -13 -8 -190 -141 -392 -297 l-368 -283 0 231 c0 214 -2 235 -21 274 -12 26 -36 53 -57 66 -35 22 -49 23 -275 28 -222 5 -240 6 -253 24 -12 17 -14 218 -14 1348 l0 1329 25 24 24 25 1751 0 1751 0 24 -25z m900 -2425 l0 -1055 -185 -5 c-203 -5 -229 -12 -274 -73 -19 -26 -22 -46 -26 -198 l-5 -170 -272 209 c-150 115 -280 214 -290 218 -10 5 -405 11 -878 14 l-860 5 0 215 0 215 975 5 975 5 56 26 c103 49 181 140 213 248 14 48 16 142 16 728 l0 673 278 -2 277 -3 0 -1055z" />
        <path d="M1984 4215 c-218 -47 -374 -249 -374 -483 0 -120 50 -177 157 -177 101 0 146 49 162 174 11 90 34 130 91 159 81 42 198 12 257 -64 34 -45 44 -143 20 -191 -9 -16 -66 -76 -127 -133 -132 -123 -190 -194 -235 -293 -41 -89 -55 -156 -55 -255 0 -59 5 -85 20 -110 60 -99 213 -97 272 3 9 17 22 68 27 112 13 123 35 158 189 308 200 195 242 272 242 443 0 154 -49 272 -154 370 -133 124 -317 175 -492 137z" />
        <path d="M1977 2506 c-71 -26 -107 -76 -107 -146 0 -97 64 -160 163 -160 70 0 108 18 142 67 50 74 26 180 -50 224 -43 26 -103 31 -148 15z" />
      </g>
    </svg>
  )
}

export default FAQIcon
